import { createRouter, createWebHistory } from 'vue-router';
import { guideRoutes } from '@/utils/guideRoutes';
import routeName from './constant';
import moduleRoutes from './modules/index';
import moduleHeaderRoutes from './modules/indexHeader';
import moduleStepRoutes from './modules/indexStep';
import uatRoutes from './uatRoutes';
import { letterRoute } from '@/router/modules/letter';

const routes = [
    {
        path: '/',
        redirect: '/err/404',
        // redirect: routeName.HOME,
        component: () => import('@/components/routerView/LayoutNoHeader.vue'),
        children: [
            ...moduleRoutes,
        ],
    },
    ...uatRoutes,
    {
        path: '/',
        component: () => import('@/components/routerView/LayoutHearder.vue'),
        children: [
            {
                path: 'contact-info',
                name: routeName.CONTACT_INFO,
                component: () => import('@/views/editTelAndMail/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '確認聯絡資料',
                    pageTitle: '請確認此保單資料',
                    unableBack: true,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.SSO_Login];
                    const guideRoute = guideRoutes(from, whiteList, true);
                    next(guideRoute);
                },
            },
            ...moduleHeaderRoutes,
        ],
    },
    {
        path: '/',
        redirect: '/err/404',
        // redirect: routeName.HOME,
        component: () => import('@/components/routerView/LayoutVipNoHeader.vue'),
        children: [
            ...moduleRoutes,
        ],
    },
    {
        path: '/apply',
        component: () => import('@/components/routerView/LayoutHeaderStepCard.vue'),
        children: [
            {
                path: 'OTP',
                name: routeName.OTP,
                component: () => import('@/views/otp/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '動態密碼驗證',
                    leaveAlert: true,
                    pageTitle: '請輸入動態密碼',
                    unableBack: true,
                },

            },
            {
                path: 'finish',
                name: routeName.FINISH,
                component: () => import('@/views/finish/Index.vue'),
                meta: {
                    auth: true,
                    metaTitle: '委託受理完成',
                    leaveAlert: false,
                    pageTitle: '委託受理完成',
                    unableBack: false,
                },
                beforeEnter: (to, from, next) => {
                    const whiteList = [routeName.OTP, routeName.A3_OTP, routeName.A4_OTP, routeName.A5_OTP, routeName.A6_OTP, routeName.ENOTIFY_REGISTER];
                    const guideRoute = guideRoutes(from, whiteList, false);
                    next(guideRoute);
                },
            },
            ...moduleStepRoutes,
        ],
    },
    {
        path: '/notify',
        component: () => import('@/components/routerView/LayoutNotify.vue'),
        children: [
            {
                path: 'announcement',
                name: routeName.ANNOUNCEMENT,
                component: () => import('@/views/notifyPage/Announcement.vue'),
                meta: {
                    auth: false,
                    metaTitle: '系統公告',
                    hideMenu: false,
                    pageTitle: '系統公告',
                },
            },
        ],
    },
    {
        path: '/err',
        component: () => import('@/components/routerView/LayoutWarning.vue'),
        children: [
            {
                path: '401',
                name: routeName.NO_AUTH,
                component: () => import('@/views/warningPage/401page.vue'),
                meta: {
                    auth: false,
                    metaTitle: '沒有權限',
                    hideMenu: false,
                    pageTitle: '沒有使用權限',
                },
            },
            {
                path: '404',
                name: routeName.NOTFOUND,
                component: () => import('@/views/warningPage/404page.vue'),
                meta: {
                    auth: false,
                    metaTitle: '找不到頁面',
                    hideMenu: false,
                    pageTitle: 'OPPS',
                },
            },
            {
                path: '403',
                name: routeName.FORBIDDEN,
                component: () => import('@/views/warningPage/403page.vue'),
                meta: {
                    auth: false,
                    metaTitle: '身分驗證失敗',
                    hideMenu: false,
                    pageTitle: '登入發生錯誤',
                },
            },
        ],
    },
    {
        path: '/ssoLogin',
        name: routeName.SSO_Login,
        component: () => import('@/views/login/SSOLogin.vue'),
        meta: {
            auth: false,
            metaTitle: '單一登入',
            hideMenu: false,
            pageTitle: '單一登入',
        },
    },
    {
        path: '/redirect/account',
        name: routeName.REDIRECT_ACCOUNT,
        component: () => import('@/views/redirect/Account.vue'),
        meta: {
            auth: false,
            metaTitle: '單一登入',
            hideMenu: false,
            pageTitle: '單一登入',
        },
    },
    ...letterRoute,
    {
        path: '/:pathMatch(.*)*',
        redirect: '/err/404',
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: () => ({
        top: 0,
    }),
    routes,
});

export default router;
